export enum BaseDataManagementTabs {
  Overview,
  LocationImport,
  DepartmentImport,
  BranchImport,
  InviteUserImport,
  CreateNewEmployeeImport,
  ImportHistory,
}
